// extracted by mini-css-extract-plugin
export default {"squaredImageWrapper":"SquaredImage_squaredImageWrapper__ZAJVY","circle":"SquaredImage_circle__3QSg-","imageInner":"SquaredImage_imageInner__XVmui"};